export function getClusterLayerIds(sourceName) {
  return {
    circles: `${sourceName}_clusters`,
    count: `${sourceName}_cluster_count`
  };
}

export function setClusterLayerVisibility(sourceName, visibility) {
  const ids = this.getClusterLayerIds(sourceName);
  if (this.map.getLayer(ids.circles)) {
    this.map.setLayoutProperty(ids.circles, 'visibility', visibility);
  }
  if (this.map.getLayer(ids.count)) {
    this.map.setLayoutProperty(ids.count, 'visibility', visibility);
  }
}
